// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Each word rises out of its own mask. The padding keeps descenders (g, p, y)
   inside the mask; the negative margin cancels it so line height is unchanged. */
.textReveal_mask__rn0Av {
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  padding-bottom: 0.14em;
  margin-bottom: -0.14em;
  white-space: nowrap;
}
.textReveal_inner__nSM7u {
  display: inline-block;
  will-change: transform;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/ANIMATION/TextReveal/textReveal.module.css"],"names":[],"mappings":"AAAA;iFACiF;AACjF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/* Each word rises out of its own mask. The padding keeps descenders (g, p, y)\n   inside the mask; the negative margin cancels it so line height is unchanged. */\n.mask {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: top;\n  padding-bottom: 0.14em;\n  margin-bottom: -0.14em;\n  white-space: nowrap;\n}\n.inner {\n  display: inline-block;\n  will-change: transform;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mask": `textReveal_mask__rn0Av`,
	"inner": `textReveal_inner__nSM7u`
};
export default ___CSS_LOADER_EXPORT___;
